document.querySelectorAll('.count').forEach(function (element) {
    const originalText = element.textContent; // Store the original text
    const matches = originalText.match(/[\d,.]+/g); // Extract all numeric parts

    if (matches) {
      const numberParts = matches.map(num => parseFloat(num.replace(/[^\d.]/g, ''))); // Convert to numbers
      const formattedParts = matches.map(num => num); // Keep original formatting

      numberParts.forEach((endValue, index) => {
        const duration = 3000; // Animation duration
        let startValue = 0; // Start counting from 0
        let startTime = null;

        function animateCounter(timestamp) {
          if (!startTime) startTime = timestamp;
          const progress = timestamp - startTime;
          const currentValue = Math.min(
            (progress / duration) * (endValue - startValue) + startValue,
            endValue
          );

          // Format the current value with the same decimal places as the original number
          const decimalPlaces = (formattedParts[index].split('.')[1] || '').length;
          const formattedValue = currentValue.toFixed(decimalPlaces).replace('.', ',');

          // Replace the numeric part in the original text while keeping non-numeric parts intact
          const updatedText = originalText.replace(matches[index], () => {
            return formattedValue;
          });

          element.textContent = updatedText;

          if (progress < duration) {
            requestAnimationFrame(animateCounter);
          }
        }

        requestAnimationFrame(animateCounter);
      });
    }
  });